module.exports = __webpack_public_path__ + "static/wpack/extracted/mit-picd9b851297e6a46d2208eefe28d0ba7d5.png";